import { useDispatch } from 'react-redux';

import { showErrorAction } from 'containers/Notification/actions';
import { useSetCampaignActionsMutation } from 'generated/graphql';

export const useSetCampaignActions = () => {
  const dispatch = useDispatch();

  const onError = () => {
    dispatch(showErrorAction('An error occurred adding actions to the campaign'));
  };

  const [setCampaignActions] = useSetCampaignActionsMutation({
    onError,
    update: (cache) => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'actions' });
    },
  });

  const onSetCampaignActions = async ({
    campaignId,
    actionIds,
  }: {
    actionIds: string[];
    campaignId: string;
  }) => {
    await setCampaignActions({
      variables: {
        campaignId,
        actionIds,
      },
    });
  };

  return {
    onSetCampaignActions,
  };
};
